import clsx from 'clsx'
import React from 'react'

export function SidebarLayout({
  sidebar,
  className,
  children
}: { sidebar: React.ReactNode } & React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={clsx([
        className,
        // Basic layout
        'relative h-full w-full',

        // Background color
        'bg-white',

        // Dark mode
        'dark:bg-zinc-950'
      ])}
    >
      <div
        className={clsx([
          'absolute inset-y-0 hidden lg:block',

          // Pane width
          'lg:w-64 xl:w-72',

          // Border
          'border-r border-zinc-950/10 dark:border-white/10'
        ])}
      >
        {sidebar}
      </div>
      <div className="h-full lg:pl-64 xl:pl-72">{children}</div>
    </div>
  )
}
